import { useApi } from '../useApi'
// eslint-disable-next-line import/no-unresolved
import { getCmsBlocks } from 'data-api'

export const useCmsBlocks = ({ ids = [], identifiers = [], paused, options } = {}) => {
	const {
		data = [],
		error,
		isValidating,
		mutate,
		cancel,
		cancelled,
	} = useApi({
		method: getCmsBlocks,
		args: {
			where: identifiers ? { idx: { inq: identifiers } } : { content_id: { inq: ids } },
		},
		paused: paused || (!ids?.length && !identifiers?.length),
		options,
	})

	return {
		blocks: data,
		loading: isValidating,
		error,
		mutate,
		cancel,
		cancelled,
	}
}
